import Vue from 'vue'
import types from './types'

export default {
  [types.mutations.add]: (state, crop) => {
    if (!state.crops.some(x => x.key === crop.key)) {
      state.crops.push(crop)
      if (crop['crop_group']) {
        crop['crop_group'].forEach(cg => {
          if (!state.cropGroups.some(x => x === cg)) state.cropGroups.push(cg)
        })
      }
    }
  },
  [types.mutations.edit]: (state, crop) => {
    var y = state.crops.filter(x => x.key === crop.key)[0]
    Vue.set(state.crops, state.crops.indexOf(y), crop)
    if (crop['crop_group']) {
      crop['crop_group'].forEach(cg => {
        if (!state.cropGroups.some(x => x === cg)) state.cropGroups.push(cg)
      })
    }
  },
  [types.mutations.delete]: (state, crop) => {
    var y = state.crops.filter(x => x.key === crop.key)[0]
    state.crops.splice(state.crops.indexOf(y), 1)
  },
  [types.mutations.filterCrops]: (state, filter) => {
    state.filter = filter
  }
}
